import { Card } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { FileText, Target, Zap, CheckCircle2 } from "lucide-react";

interface ATSCategoryScoresProps {
  formatting: number;
  keywords: number;
  content: number;
  technical: number;
}

export const ATSCategoryScores = ({ 
  formatting, 
  keywords, 
  content, 
  technical 
}: ATSCategoryScoresProps) => {
  const categories = [
    {
      name: "Formatting & Structure",
      score: formatting,
      max: 25,
      icon: FileText,
      description: "File format, fonts, sections, bullets"
    },
    {
      name: "Keyword Optimization",
      score: keywords,
      max: 30,
      icon: Target,
      description: "Job matching, industry terms, density"
    },
    {
      name: "Content Parsing",
      score: content,
      max: 25,
      icon: Zap,
      description: "Contact info, experience, achievements"
    },
    {
      name: "Technical Checks",
      score: technical,
      max: 20,
      icon: CheckCircle2,
      description: "Images, text boxes, spell check"
    }
  ];

  const getScoreColor = (score: number, max: number) => {
    const percentage = (score / max) * 100;
    if (percentage >= 90) return "text-green-600";
    if (percentage >= 75) return "text-yellow-600";
    return "text-red-600";
  };

  return (
    <div className="grid md:grid-cols-2 gap-4">
      {categories.map((category) => {
        const Icon = category.icon;
        const percentage = (category.score / category.max) * 100;
        
        return (
          <Card key={category.name} className="p-6">
            <div className="flex items-start gap-4">
              <div className="p-3 bg-primary/10 rounded-lg">
                <Icon className="h-6 w-6 text-primary" />
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-semibold">{category.name}</h3>
                  <span className={`text-xl font-bold ${getScoreColor(category.score, category.max)}`}>
                    {category.score}/{category.max}
                  </span>
                </div>
                <p className="text-sm text-muted-foreground mb-3">
                  {category.description}
                </p>
                <Progress value={percentage} className="h-2" />
                <div className="flex justify-between mt-1 text-xs text-muted-foreground">
                  <span>0</span>
                  <span>{category.max}</span>
                </div>
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
};
